import React, { useState } from 'react';
import { Modal, Button, Space, Typography, message } from 'antd';
import HierarchicalPanelPicker from './HierarchicalPanelPicker';
import { SourceProcess, SourceScene, SourcePanel } from '../../types';

const { Text } = Typography;

interface ManualReferenceModalProps {
  visible: boolean;
  onClose: () => void;
  onSelect: (panelId: string) => Promise<void>;
  processes: SourceProcess[];
  scenes: SourceScene[];
  panels: SourcePanel[];
  loading?: boolean;
  defaultProcessId?: string;
  defaultSceneId?: string;
}

const ManualReferenceModal: React.FC<ManualReferenceModalProps> = ({
  visible,
  onClose,
  onSelect,
  processes,
  scenes,
  panels,
  loading = false,
  defaultProcessId,
  defaultSceneId,
}) => {
  const [selectedPanelId, setSelectedPanelId] = useState<string | undefined>();

  const handleConfirm = async () => {
    if (!selectedPanelId) {
      message.warning('Vui lòng chọn một panel để tham chiếu.');
      return;
    }
    await onSelect(selectedPanelId);
    setSelectedPanelId(undefined); // Reset selection after success to allow adding another one
  };

  return (
    <Modal
      title="Thêm ảnh tham chiếu thủ công"
      open={visible}
      onCancel={onClose}
      onOk={handleConfirm}
      confirmLoading={loading}
      width={600}
      destroyOnClose
      okText="Xác nhận & Phân tích AI"
      cancelText="Hủy"
    >
      <Space direction="vertical" size="large" style={{ width: '100%', padding: '10px 0' }}>
        <Text>
          Chọn một panel có ảnh tham chiếu tốt (bố cục rõ, trang phục khớp). Với panel VIDEO, hệ thống sẽ dùng cả
          ảnh đầu cảnh (first frame) và frame cuối video khi gen ảnh. AI sẽ phân tích và gắn nhãn loại tham chiếu.
        </Text>
        
        <HierarchicalPanelPicker
          processes={processes}
          scenes={scenes}
          panels={panels}
          value={selectedPanelId}
          onChange={setSelectedPanelId}
          placeholder="Tìm và chọn panel tham chiếu..."
          initialProcessId={defaultProcessId}
          initialSceneId={defaultSceneId}
        />
        
        <div style={{ background: '#fff7e6', padding: '12px', borderRadius: '4px', border: '1px solid #ffd591' }}>
          <Text type="warning" style={{ fontSize: '12px' }}>
            * Panel IMAGE cần có `imagePath`. Panel VIDEO: có `firstFrameUrl` và/hoặc `imagePath` (end frame) sau khi đã gen video.
          </Text>
        </div>
      </Space>
    </Modal>
  );
};

export default ManualReferenceModal;
